var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3.45588,
    fill: "#FFF4F4",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_3514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3675 20.7892C21.9311 20.7892 21.5784 21.1427 21.5784 21.5784V24.735C21.5784 25.1699 21.2248 25.5242 20.7892 25.5242H18.4217V13.6867C18.4217 13.0127 17.9924 12.4106 17.3469 12.1865L17.1133 12.1084H20.7892C21.2248 12.1084 21.5784 12.4627 21.5784 12.8975V15.265C21.5784 15.7006 21.9311 16.0542 22.3675 16.0542C22.8039 16.0542 23.1567 15.7006 23.1567 15.265V12.8975C23.1567 11.5922 22.0945 10.53 20.7892 10.53H12.3057C12.2757 10.53 12.2504 10.5434 12.2212 10.5474C12.1833 10.5442 12.147 10.53 12.1084 10.53C11.2379 10.53 10.53 11.2379 10.53 12.1084V26.3134C10.53 26.9873 10.9593 27.5894 11.6049 27.8136L16.3541 29.3966C16.5151 29.4464 16.6753 29.47 16.8434 29.47C17.7138 29.47 18.4217 28.7621 18.4217 27.8917V27.1025H20.7892C22.0945 27.1025 23.1567 26.0403 23.1567 24.735V21.5784C23.1567 21.1427 22.8039 20.7892 22.3675 20.7892Z",
    fill: "#EA0208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2384 17.8636L26.0818 14.707C25.8561 14.4813 25.5167 14.4134 25.2216 14.5357C24.9272 14.658 24.7347 14.9461 24.7347 15.2649V17.6324H21.578C21.1424 17.6324 20.7888 17.9859 20.7888 18.4216C20.7888 18.8572 21.1424 19.2107 21.578 19.2107H24.7347V21.5782C24.7347 21.8971 24.9272 22.1851 25.2216 22.3074C25.5167 22.4297 25.8561 22.3619 26.0818 22.1362L29.2384 18.9795C29.547 18.6709 29.547 18.1722 29.2384 17.8636Z",
    fill: "#EA0208"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_3514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.94,
    height: 18.94,
    fill: "white",
    transform: "translate(10.53 10.53)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3dc59ded5cdca6ddca3a044eccce7478.svg";
export { ForwardRef as ReactComponent };